<div class="modal-body text-center">
  <h4 class="modal-title font-weight-bold">
    {{ title }}
  </h4>
  <p [innerHTML]="message" class="mt-3"></p>
</div>
<div class="text-center d-block mt-3">
  <button
    (click)="close(true)"
    type="button"
    class="btn rounded"
    [ngClass]="data.confirmBtnCssClass || 'btn-primary'"
    >
    {{ confirmButtonText }}
  </button>
  @if (cancelButtonText) {
    <button
      type="button"
      class="btn rounded btn-light"
      (click)="close()"
      >
      {{ cancelButtonText }}
    </button>
  }
</div>
